
var swiper = new Swiper(".instagram-feed-swiper", {
   loop: true,
    slidesPerView: 4,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true
    // },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      1024: { slidesPerView: 4, },
      768: { slidesPerView: 2, spaceBetween: 10, },
      500: { slidesPerView: 1.2,spaceBetween: 10, centeredSlides:true },
      430: { slidesPerView: 1.2,spaceBetween: 10, centeredSlides:true },
      414: { slidesPerView: 1.2,spaceBetween: 10, centeredSlides:true },
      393: { slidesPerView: 1.2,spaceBetween: 10, centeredSlides:true },
      360: { slidesPerView: 1.2,spaceBetween: 10, centeredSlides:true },
    }
});


